export class StatusToIconValueConverter {
	public toView(value) {
		let atoInterfaceIcon = '';
		switch (value) {
			case 'Q': // status generated
				atoInterfaceIcon =
					'<i class="fas fa-sign-out-alt text-warning" aria-hidden="true"></i>';
				break;
			case 'P': // status pending
				atoInterfaceIcon =
					'<i class="fas fa-clock text-warning" aria-hidden="true"></i>';
				break;
			case 'R': // status completed
				atoInterfaceIcon =
					'<i class="fas fa-check text-success" aria-hidden="true"></i>';
				break;
			case 'E': // status error
				atoInterfaceIcon =
					'<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>';
				break;
			case 'J': // status rejected
				atoInterfaceIcon =
					'<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>';
				break;
			case 'K': // status rejected internal error
				atoInterfaceIcon =
					'<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>';
				break;
			case 'C': // status cencelled
				atoInterfaceIcon =
					'<i class="fas fa-ban text-warning" aria-hidden="true"></i>';
				break;
			default:
				atoInterfaceIcon =
					'<i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>';
		}

		return atoInterfaceIcon;
	}
}
